import React, { Fragment, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import className from 'classnames';

import { FaWifi } from 'react-icons/fa';

import { Button } from '@components';
import useLayoutContext from '@hooks/useLayoutContext';
import useSelectedPackages from '@hooks/useSelectedPackages';

import { STORAGE_URL } from 'sdk-apogee';
import usePackages from '@hooks/usePackages';
import { FCWithChildren } from '@types';
import { MdImportantDevices } from 'react-icons/md';

const Service: FCWithChildren<{}> = () => {
  const history = useHistory();

  const { isMobile } = useLayoutContext();

  const { data = [] } = useSelectedPackages();
  const { data: packages = [] } = usePackages();
  const bodyCls = className('flex w-full', isMobile ? 'flex-col' : 'flex-row');
  const btnContainerCls = className(
    'flex flex-wrap',
    isMobile ? 'flex-col' : 'flex-row w-4/5 justify-center',
  );

  const handleUpgradeClick = () => history.push('/services');

  const internetPackage = data && data[0];

  const htmlToRender = useMemo(
    () => internetPackage?.planDescriptionHtml || null,
    [internetPackage],
  );

  const ButtonsContainer = () =>
    packages.length < 2 ? null : (
      <div className={btnContainerCls}>
        <Button className="w-40 m-1" onClick={handleUpgradeClick} block={isMobile}>
          See Plans
        </Button>
      </div>
    );

  return (
    <section className="flex flex-col w-full">
      <h2 className="my-2">Your Service</h2>
      <div className="flex gap-4 items-center py-4">
        <div className="rounded-full h-32 w-32 bg-gray-300 flex items-center justify-center">
          {internetPackage?.icon ? (
            <img src={`${STORAGE_URL}${internetPackage.icon}`} alt="logo" />
          ) : (
            <FaWifi className="text-gray-400" size={50} />
          )}
        </div>

        <div className="flex gap-2">
          {internetPackage ? (
            <div className="flex flex-col gap-2">
              <h2>{internetPackage?.planName}</h2>
              <div
                className="flex flex-col"
                dangerouslySetInnerHTML={{
                  __html: htmlToRender || '',
                }}
              />
            </div>
          ) : (
            <div className="flex flex-col gap-2">
              <h2>No package selected</h2>
              {packages.length > 1 && (
                <span className="my-1 text-base font-semibold">
                  Click on "See Plans" to select one
                </span>
              )}
            </div>
          )}
          <ButtonsContainer />
        </div>
      </div>
    </section>
  );
};

export default Service;
